import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Helmet } from 'react-helmet';
import './Mybumpie.css';
import Cookies from "js-cookie";
// import * as actions from '../Actions';
import { fetchInitialData } from "../../fetchData";
import Right from '../../right/Right';
import Service from '../../service/Service';


const service = new Service();

class Mybumpie extends Component {
    constructor(props) {
        super(props);
        let initialData = {};
        let getBanner = [];
        let Mybumpiedata = [];
        let FrameListData=[]
        let currentWeek='';

        if (__isBrowser__ && window.__initialData__ && window.__initialData__['initialData'] && window.__initialData__['initialData']['result']) {
            Mybumpiedata = window.__initialData__['initialData']['result'];
            FrameListData=Mybumpiedata.frameList;
            currentWeek=Mybumpiedata.currentWeek;
            delete window.__initialData__;
        } else {
            if (props.staticContext && props.staticContext.initialData && props.staticContext.initialData['initialData'] && props.staticContext.initialData['initialData']['result']) {
                Mybumpiedata = props.staticContext.initialData['initialData']['result'];
                FrameListData=Mybumpiedata.frameList;
                currentWeek=Mybumpiedata.currentWeek;
            }
        }
        this.state = {
            initialData: initialData,
            Mybumpiedata: Mybumpiedata,
            FrameListData:FrameListData,
            currentWeek:currentWeek,
            shortMonth: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
            IsExpected: false
        }
    }
    static initialAction(reqUrl, ftk, authData, uId, childData) {
        var selectedChild='';
        if (childData && childData['UserChildList'] && childData['UserChildList'].length > 0) {
            if (childData['UserChildList'][0].IsExpected != 1) {
                selectedChild = childData['UserChildList'][0].ChildId;
            } else {
                selectedChild = childData['UserChildList'][1].ChildId;
            }
        }
        var header = {
            'Content-Type': 'application/json',
            'ftk': ftk,
            'uid': uId,
            'access-token': authData['access-token'],
            'user-agent': global.userAgent,
            'isdesktop': global.isdesktop
        }
        
        var url= global.api_url + "bumpie/getmybumpiedetailsdesktop";
        let body= JSON.stringify({
                "childId": selectedChild,
                "pageSize": "10",
                "pageNo": "1",
                "categoryId": ""
            });
        return fetchInitialData(url, JSON.stringify(header), body);
    }
    componentDidMount() {
        console.log("Mybumpiedata====================>",this.state.Mybumpiedata);
        // console.log("GetBanner====================>",this.state.getBanner);
        // document.querySelector('#banner-slider').slidesjs({
        //     m_navigation: true,
        //     play: {
        //         active: true,
        //         auto: true,
        //         interval: 4000,
        //         swap: true
        //     }
        // });                
        // document.querySelector('.slidesjs-previous').innerHTML='';
        // document.querySelector('.slidesjs-next').innerHTML='';
    
        // var bannerheight =  document.querySelector('.banner-img img').style.height;
        // document.querySelector('.slidesjs-container').style.height=bannerheight;
        // document.querySelector('.slidesjs-control').style.height=bannerheight;
        if (global.userAry['IsExpected']) {
            this.setState({ IsExpected: true });
        } else {
            this.setState({ IsExpected: false });
        }
        if (navigator.onLine) {
            if (!this.state.Mybumpiedata || (this.state.Mybumpiedata && Object.keys(this.state.Mybumpiedata).length < 1)) {
                service.showLoader();
                this.getMybumpieData();
            } else {
                localStorage.setItem('MybumpieData', JSON.stringify(this.state.Mybumpiedata));
            }
            // if (!this.state.getBanner || (this.state.getBanner && this.state.getBanner.length < 1)) {
            //     service.showLoader();
            //     this.getBannerData();
            // } else {
            //     localStorage.setItem('getBanner', JSON.stringify(this.state.getBanner));
            // }
            service.hideLoader();
        } else {
            if (localStorage.getItem('MybumpieData')) {
                this.setState({
                    Mybumpiedata: JSON.parse(localStorage.getItem('MybumpieData'))
                });
            }
            // if (localStorage.getItem('getBanner')) {
            //     this.setState({
            //         getBanner: JSON.parse(localStorage.getItem('getBanner'))
            //     });
            // }
            service.hideLoader();
        }
    }
    getMybumpieData() {
        let childData = global.userAry['childData']['UserChildList'];
        console.log("getMybumpieData========================>",childData);
        var selectedChild=0;
        if (global.userAry['childData'] && childData && childData.length > 0) {
            if (childData[0].IsExpected != 1) {
                selectedChild = childData[0].ChildId;
            } else {
                selectedChild = childData[1].ChildId;
            }
        }
        var postData={
            "childId": selectedChild,
            "pageSize": "10",
            "pageNo": "1",
            "categoryId": ""
        }
        console.log("postData===============>",postData);
        var url = global.api_ci_url + "MyBumpie/getMyBumpieData";
        // var url = global.api_url + "bumpie/getmybumpiedetailsdesktop";
        service.postServiceCall(url, postData).then((json) => {
            console.log("framelist==============>",json['result']);
            if (json['result']) {
                this.setState({
                    Mybumpiedata: json['result'],
                    FrameListData:json['result'].frameList,
                    currentWeek:json['result']['currentWeek'],
                }, () => {  });
                localStorage.setItem('Mybumpiedata', JSON.stringify(json));
            }
            service.hideLoader();
        }).catch((error) => {
            console.error(error);
            service.hideLoader();
        });
    }
    // getBannerData(){
    //     var postData={
    //         "moduleId": "5"
    //     }
    //     // var url = global.api_ci_url + "MyBumpie/getBannerData";
    //     var url= global.api_url + "config/getdfpbannerdata";
    //     service.postServiceCall(url, postData).then((json) => {
    //         console.log("BannerData==============>",json['result']);
    //         if (json['result']) {
    //             this.setState({
    //                 getBanner: json['result']
    //             }, () => {  });
    //             localStorage.setItem('getBanner', JSON.stringify(json));
    //         }
    //         service.hideLoader();
    //     }).catch((error) => {
    //         console.error(error);
    //         service.hideLoader();
    //     });
    // }
    uploadPage(e,weekNumber,startWeekDate){
        console.log("startweekdate",startWeekDate)
        let D = new Date(startWeekDate).toString().split(" ");
        var startWeekDate=(D[2] + "-" + D[1] + "-" + D[3]);
        var currentWeek = this.state.currentWeek;
        if (!global.ftk) {
            document.querySelector(".alertmsg").innerHTML=("Please login");
            document.querySelector('.alertMsg-overlay').style.display="block";
            window.location.href = global.loginUrl + '?URL=' + global.currentURL;  
            return false;
        }
        if (!global.userAry['userName']) {
            document.querySelector(".alertmsg").innerHTML=("Please complete your profile!");
            document.querySelector(".alert-popup").css=("left", '1%');
            document.querySelector('.alertMsg-overlay').style.display="block";
            window.location.href = 'my-account/myprofile?URL=' + global.currentURL;
            return false;
        }
        if (parseInt(currentWeek) >= parseInt(weekNumber) || this.state.IsExpected == false) {
            Cookies.set("frameId", e.target.parentNode.getAttribute('data-id'));
            Cookies.set("frameUrl", e.target.parentNode.getAttribute('data-url'));
            Cookies.set("weekNumber", e.target.parentNode.getAttribute('data-weekNumber'));
            Cookies.set("startweekdate",e.target.parentNode.getAttribute('data-startweekdate'));
            this.props.history.push('/tools/uploadmybumpie');
        }
        else {
            document.querySelector(".alertmsg").innerHTML=("week " + weekNumber + " will be activated on " + startWeekDate + ".");
            document.querySelector(".alertMsg-overlay").style.display="block";
            setTimeout(() => {
                document.querySelector(".alertMsg-overlay").style.display="none";
            }, 1500);
        }
    }
    render() {
        return (
            <main className="main-container Mybumpie">
                <Helmet
                    title="Capture Your Baby Bump Week by Week - FirstCry Parenting"
                    meta={[
                        { "name": "description", "content": "With the news of pregnancy, together come’s happiness, responsibility and your bump. Capture your every baby bump week by week while pregnant along with date & other details." }, { "name": "atdlayout", "content": "tools_sp" }
                    ]}
                />
                <div className="title">
                    <div className="breadcrumb R11_9e">
                        <span><Link to={service.getRedirectUrl("/")} className="R11_9e">Home</Link></span>
                        <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                        <span><Link to={service.getRedirectUrl("/tools")} className="R11_9e">Tools</Link></span>
                        <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                        <span>My Bumpie</span>
                    </div>
                    <h1 className="B24_00">My Bumpie</h1>
                </div>
                <div className="sub-container left">
                    <div className="data-container left">
                        <div id="childDropdown">
                            {global.ftk
                            ? <div>
                               <div className="drop-down">
                                   {/* <input type="hidden" id="selectedChildId" name="selectedChildId" value=""/> */}
                                    <div className="diet-title M15_pink"> My Bumpie ({global.userAry['userName']})</div>
                                </div>
                            </div> :null
                        }
                        </div>
                        <div className="bumpie_container">
                            {/* <div className="memoriesContest-cnt">
                                <div className="memories-banner">
                                    <div id="banner-slider">  
                                        <a className="banner-img" href="javascript:void(0);" title="" alt=""  data-id="1">
                                        <img src={require('../images/dummy-banner-01.jpg')} title="image"/>
                                        </a>
                                        <a className="banner-img" href="javascript:void(0);" title="" alt=""  data-id="2">
                                        <img src={require('../images/dummy-banner-02.jpg')} title="image"/>
                                        </a>
                                        <a className="banner-img" href="javascript:void(0);" title="" alt=""  data-id="3">
                                        <img src={require('../images/dummy-banner-03.jpg')} title="image"/>
                                        </a>
                                        <a className="slidesjs-previous slidesjs-navigation" href="#" title="Previous" data-icon-font="g"></a>
                                        <a className="slidesjs-next slidesjs-navigation" href="#" title="Next" data-icon-font="h"></a>
                                    </div>
                                </div>
                            </div> */}
                            <div className="frame_bumpie">
                                <div className="frame_title">
                                    <h2 className="M15_61">Capture Your Bumpie Every Week</h2>
                                </div>
                                <div className="parenting-frame">
                                    <ul className="frame fl">
                                        {this.state.FrameListData && this.state.FrameListData.length > 0 && this.state.FrameListData.map((frameList, index) => frameList.isBumpieLoaded == 0 ?
                                            (
                                                <li key={index} className="frames fl">
                                                    <div className="upload_href" data-id={frameList.frameId} data-url={frameList.frameImage} data-startweekdate={frameList.startWeekDate} data-weekNumber={frameList.weekNumber} data-currentWeek={this.state.currentWeek} onClick={(e)=>{this.uploadPage(e,frameList.weekNumber,frameList.startWeekDate)}}>
                                                        <img src={frameList.frameImage} alt={frameList.frameImage} title={frameList.frameImage} className="dev_bumpieFrame"/>
                                                        <div className="R14_9e add_photo" data-id={frameList.frameId} data-url={frameList.frameImage} data-startweekdate={frameList.startWeekDate} data-weekNumber={frameList.weekNumber} data-currentWeek={this.state.currentWeek}>
                                                            <span data-icon-font="x" className="icon"></span>
                                                            Upload Photo
                                                        </div>
                                                    </div>
                                                </li>
                                            ) : (
                                                <li className="frames fl">
                                                    <div className="href" data-id={frameList.frameId} data-url={frameList.imageUrl} data-weekNumber={frameList.weekNumber} data-currentWeek={this.state.currentWeek} target="_self">
                                                        <img src={frameList.imageUrl} alt={frameList.imageUrl} title={frameList.imageUrl} />
                                                    </div>
                                                </li>
                                            )
                                        )}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Right url={this.props.match.url} />
            </main>
        )

    }
}

export default Mybumpie;



// WEBPACK FOOTER //
// src/shared/tools/Mybumpie/Mybumpie.js